export const stationTypeDict = {
  Water: '水质',
  Air: '大气',
  A01: '标准站',
  A0701: '单雨量站',
  A0301: '工地扬尘站',
  A0201: '边界点',
  A0401: '出租车',
  A1101: 'OBD柴油车',
  A0601: '企业摄像头',
  A0101: '国控点',
  A0501: '排污企业',
  A0702: '湿雨点站',
  A0502: '餐饮油烟',
  A1102: '尾气检测站',
  A0102: '省控点',
  A02: '微观站',
  A0602: '高空摄像头',
  A0202: '国控周边店',
  A0302: '道路扬尘站',
  A0402: '二轮车',
  A1103: '尾气门',
  A0103: '市控点',
  A0203: '企业点',
  A0403: '三轮车',
  A0503: '渣土车',
  A0603: '工地摄像头',
  A0703: '多要素站',
  A04: '移动站',
  A0604: '黑烟车摄像头',
  A0204: '其他',
  A0104: '区控点',
  A0404: '公务车',
  A0504: '渣土场',
  A03: '扬尘站',
  A14: '无人机',
  A0506: '非道路移动机械',
  A0405: '公交车',
  A0505: '加油站',
  A15: '走航车',
  A0406: '洒水车',
  A08: '降尘点',
  A0407: '雾炮车',
  A0507: '加油枪',
  A09: 'VOC检测站',
  A0408: '其他',
  A05: '监管源',
  A11: '线源',
  A06: '摄像头',
  A07: '气象站',
  A16: '降雨站',
  A10: '雷达',
  A12: '网格员',
  W0103: '市控',
  W0102: '省控',
  W020101: '河流点位',
  W0403: '单独摄像头',
  W0302: '污水处理厂',
  W0201: '小型站',
  W0402: '站点摄像头',
  W020102: '水库点位',
  W0301: '排污企业',
  W0401: '企业摄像头',
  W04: '摄像头',
  W0303: '入河排污口',
  W01: '标准站',
  W02: '微观站',
  W0101: '国控',
  W03: '点源',
};
/**
 * 站点标识
 * @params splitNumber 裁剪数量
 * @params isModified 是否修饰： 例如【*】
 * */
export const stationTag = (e, isModified = true) => {
  if (!e) {
    return undefined;
  }
  const data = [
    ['COUNTRY', '国控'],
    ['PROVINCE', '省控'],
    ['CITY', '市控'],
    ['DISTRICT', '区控'],
    ['CUSTOM', '自建站'],
    ['NORMAL', '微观固定站'],
    ['DUST', '扬尘站'],
    ['VEHICLE', '车载设备'],
    ['VOC', 'VOC站'],
  ];
  const index = data.findIndex(item => item[0] === e);
  if (index > -1) {
    return isModified ? `【${data[index][1]}】` : data[index][1];
  } else {
    return '--';
  }
};

/**
 * 站点类目
 * @params splitNumber 裁剪数量
 * */
export const stationType = e => {
  const data = {
    Water: '水质',
    Air: '大气',
    A01: '标准站',
    A0701: '单雨量站',
    A0301: '工地扬尘站',
    A0201: '边界点',
    A0401: '出租车',
    A1101: 'OBD柴油车',
    A0601: '企业摄像头',
    A0101: '国控点',
    A0501: '排污企业',
    A0702: '湿雨点站',
    A0502: '餐饮油烟',
    A1102: '尾气检测站',
    A0102: '省控点',
    A02: '微观站',
    A0602: '高空摄像头',
    A0202: '国控周边店',
    A0302: '道路扬尘站',
    A0402: '二轮车',
    A1103: '尾气门',
    A0103: '市控点',
    A0203: '企业点',
    A0403: '三轮车',
    A0503: '渣土车',
    A0603: '工地摄像头',
    A0703: '多要素站',
    A04: '移动站',
    A0604: '黑烟车摄像头',
    A0204: '其他',
    A0104: '区控点',
    A0404: '公务车',
    A0504: '渣土场',
    A03: '扬尘站',
    A14: '无人机',
    A0506: '非道路移动机械',
    A0405: '公交车',
    A0505: '加油站',
    A15: '走航车',
    A0406: '洒水车',
    A08: '降尘点',
    A0407: '雾炮车',
    A0507: '加油枪',
    A09: 'VOC检测站',
    A0408: '其他',
    A05: '监管源',
    A11: '线源',
    A06: '摄像头',
    A07: '气象站',
    A16: '降雨站',
    A10: '雷达',
    A12: '网格员',
    W0103: '市控',
    W0102: '省控',
    W020101: '河流点位',
    W0403: '单独摄像头',
    W0302: '污水处理厂',
    W0201: '小型站',
    W0402: '站点摄像头',
    W020102: '水库点位',
    W0301: '排污企业',
    W0401: '企业摄像头',
    W04: '摄像头',
    W0303: '入河排污口',
    W01: '标准站',
    W02: '微观站',
    W0101: '国控',
    W03: '点源',
  };
  return data[e] ? data[e] : '--';
};
